/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadAssignment
 */
export interface LeadAssignment {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    screener_lead_id: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    role: LeadAssignmentRoleEnum;
    /**
     * 
     */
    assigned_by_user_id?: string;
    /**
     * 
     */
    assigned_via: LeadAssignmentAssignedViaEnum;
    /**
     * 
     */
    assignment_rule_id?: string;
}


/**
 * @export
 */
export const LeadAssignmentRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON',
} as const;
export type LeadAssignmentRoleEnum = typeof LeadAssignmentRoleEnum[keyof typeof LeadAssignmentRoleEnum];

/**
 * @export
 */
export const LeadAssignmentAssignedViaEnum = {
    Manual: 'MANUAL',
    Auto: 'AUTO',
} as const;
export type LeadAssignmentAssignedViaEnum = typeof LeadAssignmentAssignedViaEnum[keyof typeof LeadAssignmentAssignedViaEnum];


/**
 * Check if a given object implements the LeadAssignment interface.
 */
export function instanceOfLeadAssignment(value: object): value is LeadAssignment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('screener_lead_id' in value) || value['screener_lead_id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('assigned_via' in value) || value['assigned_via'] === undefined) return false;
    return true;
}

export function LeadAssignmentFromJSON(json: any): LeadAssignment {
    return LeadAssignmentFromJSONTyped(json, false);
}

export function LeadAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'screener_lead_id': json['screener_lead_id'],
        'user_id': json['user_id'],
        'role': json['role'],
        'assigned_by_user_id': json['assigned_by_user_id'] == null ? undefined : json['assigned_by_user_id'],
        'assigned_via': json['assigned_via'],
        'assignment_rule_id': json['assignment_rule_id'] == null ? undefined : json['assignment_rule_id'],
    };
}

export function LeadAssignmentToJSON(json: any): LeadAssignment {
    return LeadAssignmentToJSONTyped(json, false);
}

export function LeadAssignmentToJSONTyped(value?: LeadAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'screener_lead_id': value['screener_lead_id'],
        'user_id': value['user_id'],
        'role': value['role'],
        'assigned_by_user_id': value['assigned_by_user_id'],
        'assigned_via': value['assigned_via'],
        'assignment_rule_id': value['assignment_rule_id'],
    };
}

